import Layout from "../Layout";
import React, { useState, useEffect, useRef } from "react";
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


import { Package,  LockKeyhole } from "lucide-react"; // Added LockKeyhole icon for clarity
import { format, formatDistanceToNow } from 'date-fns';

import { jsPDF } from 'jspdf';



// --- IMPORTANT: Store this key securely, do NOT hardcode in production ---
const SECRET_COOKIE_KEY = "mySuperSecretCookieKey123!@#"; // Must match Register.js

// Helper functions for encryption/decryption
const encrypt = (text) => {
  return CryptoJS.AES.encrypt(text, SECRET_COOKIE_KEY).toString();
};

const decrypt = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_COOKIE_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error("Error decrypting cookie:", e);
    return null;
  }
};

const API_BASE_URL = 'https://stage.beachcabana.lk/hotelmanage/api.php';
const AUTH_HEADER = {
  headers: {
    'Authorization': 'Basic YWRtaW46cGFzc3dvcmQ=' // admin:password encoded to Base64
  }
};


// Simple Modal Component for Order Details
const OrderDetailModal = ({ order, onClose }) => {
  if (!order) return null;

  const orderDate = new Date(order.orderdt);
  const isOrderDateValid = !isNaN(orderDate.getTime());

  const handleDownloadPdf = () => {
    const pdf = new jsPDF();

    let yPos = 10;

    pdf.setFontSize(22);
    pdf.setTextColor(40, 40, 40); // Darker text color
    pdf.text(`Order Details - #${order.orderid}`, 10, yPos);
    yPos += 15;

    pdf.setFontSize(14);
    pdf.setTextColor(60, 60, 60); // Slightly lighter text color for details
    pdf.text(`Order ID: ${order.orderid}`, 10, yPos);
    yPos += 8;
    pdf.text(`Status: ${order.status}`, 10, yPos);
    yPos += 8;
    pdf.text(`Subtotal: Rs. ${parseFloat(order.subtotal).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 10, yPos);
    yPos += 8;
    pdf.text(`Order Date: ${isOrderDateValid ? format(orderDate, 'PPP p') : 'N/A'}`, 10, yPos); // More detailed date format
    yPos += 15;

    if (order.note && order.note.trim() !== '') {
      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.text(`Note: ${order.note}`, 10, yPos);
      yPos += 15;
    }

    pdf.setFontSize(18);
    pdf.setTextColor(40, 40, 40);
    pdf.text('Order Items', 10, yPos);
    yPos += 10;

    // Table Headers
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0); // Black for headers
    pdf.setFont('helvetica', 'bold');
    pdf.text('Item Name', 10, yPos);
    pdf.text('Quantity', 80, yPos);
    pdf.text('Price (Rs.)', 140, yPos);
    yPos += 5;
    pdf.line(10, yPos, 200, yPos); // Line across the page
    yPos += 8;
    pdf.setFont('helvetica', 'normal'); // Reset font

    if (order.order_list && order.order_list.length > 0) {
      order.order_list.forEach(item => {
        pdf.text(item.item_name, 10, yPos);
        pdf.text(`x${item.order_qty}`, 80, yPos);
        pdf.text(`${parseFloat(item.items_price).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 140, yPos);
        yPos += 7;
        if (yPos > 280) { // Check for page overflow
          pdf.addPage();
          yPos = 10;
        }
      });
    } else {
      pdf.setTextColor(120, 120, 120);
      pdf.text('No items found for this order.', 10, yPos);
      yPos += 7;
    }

    pdf.save(`Order_${order.orderid}.pdf`);
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center p-4 z-50 transition-opacity duration-300 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-3xl w-full max-w-xl max-h-[90vh] overflow-y-auto transform transition-all duration-300 scale-100 opacity-100 animate-fade-in-up">
        <div className="p-5 space-y-5">
       

          {/* Order Summary Grid - Adjusted for new layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-gray-700">
            <p className="flex items-center text font-semibold text-gray-900">
              Order ID: <span className="font-normal ml-1">{order.orderid}</span>
            </p>
            <p className="flex items-center text font-semibold text-gray-900">
              Order Date: <span className="font-normal ml-1">{isOrderDateValid ? formatDistanceToNow(orderDate, { addSuffix: true }) : 'N/A'}</span>
            </p>
            <p className="flex items-center text font-semibold text-gray-900">
              Subtotal: <span className="font-normal ml-1">Rs. {parseFloat(order.subtotal).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </p>
            <p className="flex items-center text font-semibold text-gray-900">
              Status:
              <dd className="me-1 mt-1 ml-2 inline-flex items-center rounded bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-900 dark:text-green-300">
              {order.status}
              </dd>
            </p>
          </div>

          {order.note && order.note.trim() !== '' && (
            // <p className="flex items-start text-gray-700 pt-4 border-t border-gray-100"><strong className=" mr-2">Note:</strong> {order.note}</p>
            <div className="flex items-center p-4 mb-4 text-sm text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800" role="alert">
              <strong className="font-medium mr-1">Note: </strong> {order.note}
              </div>

          )}

          <div className="mt-8">
            <p className="font-bold text text-gray-900 mb-5 flex items-center">
              Order Items
            </p>

            {order.order_list && order.order_list.length > 0 ? (
              <div className="grid grid-cols-1 gap-4 "> {/* Grid for item cards */}
                {order.order_list.map((item, index) => (
                  <div key={index} className="flex items-center bg-white p-3 rounded-lg border border-gray-200">
                    {/* Item Image Placeholder */}
                    <div className="w-16 h-16 bg-gray-200 rounded-md flex-shrink-0 mr-4 flex items-center justify-center text-gray-500 text-xs">
                      <img src={`images/menu/`+item.item_image} alt={item.item_name} className="rounded-md" />
                    </div>
                    <div className="flex-grow">
                      <p className="font-semibold text-gray-800 text-md">{item.item_name}</p>
                      <p className="text-gray-600 text-sm">Quantity: <span className="font-medium">x {item.order_qty}</span></p>
                    </div>
                    <p className="font-bold text-gray-700 text-lg flex-shrink-0 ml-4">
                      Rs. {parseFloat(item.items_price).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 text-center py-4">No items found for this order.</p>
            )}
          </div>
        </div>

        <div className="p-4 flex flex-col space-y-3">
          <button
            onClick={handleDownloadPdf}
            className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
          >
            Download Order PDF
          </button>
          <button
            onClick={onClose}
            className="px-6 py-2 w-full bg-white text-gray-900 font-medium text-sm rounded-lg hover:bg-gray-100 mt-3"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default function OrderTest() {
  const [showTokenPopup, setShowTokenPopup] = useState(false);
  const [tokenInput, setTokenInput] = useState(""); // Single string for the full token
  const [tokenError, setTokenError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [isRegistered, setIsRegistered] = useState(false);
  // Removed fetchError, isFetchingWifi, wifiData states
  // const [fetchError, setFetchError] = useState(null);
  // const [isFetchingWifi, setIsFetchingWifi] = useState(false);
  // const [wifiData, setWifiData] = useState(null);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // State to hold the decrypted token
  const [authToken, setAuthToken] = useState(null);


  // Create an array of refs for the 5 input fields
  const inputRefs = useRef([]);
  // Initialize the refs array with nulls, it will be populated when inputs render
  if (inputRefs.current.length !== 5) {
    inputRefs.current = Array(5).fill(null).map((_, i) => inputRefs.current[i] || React.createRef());
  }

  const navigate = useNavigate();

  // Check device registration and token on mount
  useEffect(() => {
    const checkDeviceRegistration = async () => {
      const encryptedDeviceRegistered = Cookies.get('deviceRegistered');
      const encryptedregistrationToken = Cookies.get('registrationToken');
      const encryptedRegistrationExpiry = Cookies.get('registrationExpiry');

      if (encryptedDeviceRegistered && encryptedregistrationToken && encryptedRegistrationExpiry) {
        const deviceRegistered = decrypt(encryptedDeviceRegistered);
        const registrationToken = decrypt(encryptedregistrationToken);
        const registrationExpiry = decrypt(encryptedRegistrationExpiry);

        if (deviceRegistered === 'true' && registrationToken && registrationExpiry) {
          const expiryDate = new Date(registrationExpiry);
          if (new Date() < expiryDate) {
            // setIsRegistered(true);
            setAuthToken(registrationToken); // Set the decrypted token here
            console.log("Device is registered with valid token.");
            // Removed fetchWifiDetails() call
          } else {
            Cookies.remove('deviceRegistered');
            Cookies.remove('registrationToken');
            Cookies.remove('registrationExpiry');
            Cookies.remove('currentRegistrationId');
            // setIsRegistered(false);
            setShowTokenPopup(true); // Show token popup if expired
            console.log("Registration expired. Prompting for token.");
          }
        } else {
          Cookies.remove('deviceRegistered');
          Cookies.remove('registrationToken');
          Cookies.remove('registrationExpiry');
          Cookies.remove('currentRegistrationId');
          // setIsRegistered(false);
          setShowTokenPopup(true); // Show token popup if invalid cookies
          console.log("Invalid cookies. Prompting for token.");
        }
      } else {
        // setIsRegistered(false);
        setShowTokenPopup(true); // Show token popup if no cookies found
        console.log("No registration cookies found. Prompting for token.");
      }
    };

    checkDeviceRegistration();
  }, []);

  // Fetch orders only when authToken is available and not null
  useEffect(() => {
    const fetchOrders = async () => {
      if (!authToken) {
        setLoading(false); // If no token, stop loading and show no orders
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}?param=getallorders`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic YWRtaW46cGFzc3dvcmQ='
          },
          body: JSON.stringify({ token: authToken }) // Use the decrypted token
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.code === 200) {
          setOrders(result.data);
        } else {
          // setError(result.message);
        }
      } catch (e) {
        // setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [authToken]); // Dependency array includes authToken, so it re-runs when token is set


  // Handler for individual input changes for token
  const handleChange = (e, index) => {
    const { value } = e.target;
    if (value.length > 1 || (value && !/^[a-zA-Z0-9]$/.test(value))) {
      return;
    }

    // Initialize token array with existing characters or empty strings
    const newTokenArray = Array(5).fill('');
    for (let i = 0; i < 5 && i < tokenInput.length; i++) {
      newTokenArray[i] = tokenInput[i] || '';
    }
    // Update the current index with the new value
    newTokenArray[index] = value.toUpperCase();
    const updatedToken = newTokenArray.join('');

    console.log(`handleChange: index=${index}, value=${value}, updatedToken=${updatedToken}, tokenInput=${tokenInput}`); // Debug log

    // Update state
    setTokenInput(updatedToken);
    setTokenError(""); // Clear error on input change

    // Move focus to the next input
    if (value && index < 4) {
      inputRefs.current[index + 1]?.focus();
    }

    // Trigger automatic submission if token is exactly 5 characters
    if (updatedToken.length === 5) {
      console.log("Triggering automatic submission for token:", updatedToken);
      handleTokenSubmit(null, updatedToken); // Pass updatedToken directly
    }
  };

  // Handler for keyboard navigation and backspace for token
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newTokenArray = Array(5).fill('');
      for (let i = 0; i < 5 && i < tokenInput.length; i++) {
        newTokenArray[i] = tokenInput[i] || '';
      }
      if (tokenInput[index]) {
        newTokenArray[index] = '';
        setTokenInput(newTokenArray.join(''));
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
      setTokenError(""); // Clear error on backspace
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowRight' && index < 4) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleTokenSubmit = async (e, token = tokenInput) => {
    // Prevent default form submission if triggered by a form event
    if (e) {
      e.preventDefault();
    }

    setIsLoading(true);
    setTokenError("");

    // Use the provided token (from handleChange) or fallback to tokenInput
    if (token.length !== 5) {
      console.log("Submission failed: token=", token, "tokenInput=", tokenInput); // Debug log
      setTokenError("Please enter all 5 characters of the token.");
      setIsLoading(false);
      return;
    }


    try {
      const response = await axios.post(`${API_BASE_URL}?param=tokenvalidate`, { token }, AUTH_HEADER);

      if (response.data.code === 200 && response.data.data) {
        const registrationData = response.data.data;
        const expiryDate = new Date(registrationData.registrationExpiresAt);

        if (new Date() < expiryDate) {
          Cookies.set('deviceRegistered', encrypt('true'), { expires: expiryDate });
          Cookies.set('registrationToken', encrypt(token), { expires: expiryDate });
          Cookies.set('registrationExpiry', encrypt(expiryDate.toISOString()), { expires: expiryDate });
          Cookies.set('currentRegistrationId', encrypt(registrationData.registrationToken), { expires: expiryDate });

          // setIsRegistered(true);
          setAuthToken(token); // Set the token after successful validation
          setShowTokenPopup(false);          
          setTokenInput(""); // Clear token input after successful validation
          console.log("Token verified successfully. Cookies set.");
        } else {
          setTokenError("This token has expired. Please register again or use a valid token.");
        }
      } else {
        setTokenError(response.data.message || "Invalid token. Please check and try again.");
      }
    } catch (err) {
      console.error("Error verifying token:", err);
      setTokenError("Error verifying token. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCardClick = (order) => {
    setSelectedOrder(order);
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
  };


  if (loading) {
    return (
      <Layout pageTitle="Recent Orders">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-gray-600">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-600 mb-4"></div>
          <p className="text-lg font-medium">Loading your orders...</p>
          <p className="text-sm text-gray-500 mt-1">Please wait a moment.</p>
        </div>
      </Layout>
    );
  }

  // if (error) {
  //   return (
  //     <Layout pageTitle="Recent Orders">
  //       <div className="text-center py-16 px-6 bg-red-50 text-red-700 rounded-xl shadow-lg flex flex-col items-center justify-center max-w-lg mx-auto">
  //         <CircleAlert className="h-16 w-16 text-red-400 mb-4" />
  //         <p className="font-bold text-2xl mb-3">Error Loading Orders!</p>
  //         <p className="text-lg mb-4">Something went wrong while fetching your order data.</p>
  //         <p className="text-sm text-red-600">Details: {error}</p>
  //         <p className="text-sm mt-4">Please check your internet connection or try again later.</p>
  //       </div>
  //     </Layout>
  //   );
  // }

  return (
    <Layout pageTitle="Your Orders" background="false">
      <div className="container mx-auto min-h-screen">
        {orders.length === 0 ? (
          <div className="text-center py-20 bg-white p-8 rounded-2xl shadow-xl flex flex-col items-center justify-center max-w-2xl mx-auto">
            <Package className="h-24 w-24 text-gray-300 mb-6" />
            <p className="text-xl text-gray-800 mb-3">No orders found yet!</p>
            <p className="text text-gray-600 mb-6">It looks like you haven't placed any orders with us.</p>
            {/* <button className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700">
              Start Order Now
            </button> */}
          </div>
        ) : (
          <div className="grid gap-7 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
            {orders.map((order) => {
              const orderDate = new Date(order.orderdt);
              const isOrderDateValid = !isNaN(orderDate.getTime());
              const totalQuantity = order.order_list ? order.order_list.reduce((sum, item) => sum + item.order_qty, 0) : 0;

              const getStatusBadgeClasses = (status) => {
                switch (status) {
                  case 'Shipped':
                    return 'bg-purple-100 text-purple-800 border-purple-200';
                  case 'Accepted':
                    return 'bg-orange-100 text-orange-800 border-orange-200';
                  case 'Placed':
                    return 'bg-green-100 text-green-800 border-green-200';
                  case 'Cancelled':
                    return 'bg-red-100 text-red-800 border-red-200';
                  default:
                    return 'bg-gray-100 text-gray-800 border-gray-200';
                }
              };

              return (
                <div
                  key={order.orderid}
                  className="flex flex-col bg-white p-6 rounded-2xl  hover:border-blue-400 cursor-pointer border border-gray-200 transform transition-all duration-300 hover:scale-103"
                  onClick={() => handleCardClick(order)}
                >
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h4 className="text-xl font-bold text-blue-700 mb-1 truncate">
                        Order #{order.orderid}
                      </h4>
                      <p className="text-sm text-gray-500">
                        Placed: {isOrderDateValid ? format(orderDate, 'E. MMMM do,PPPP') : 'N/A'}
                      </p>
                    </div>
                    <div className="text-2xl font-extrabold text-gray-900 flex-shrink-0 ml-4">
                      Rs. {parseFloat(order.subtotal).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                  </div>

                  <div className="border-b border-gray-100 pb-4 mb-4">
                    <p className="text-md text-gray-600">
                      {totalQuantity} {totalQuantity === 1 ? 'item' : 'items'} in this order.
                    </p>
                  </div>

                  <div className="flex justify-between items-center mt-auto">
                    <p className="text-sm text-gray-600 italic">
                       {isOrderDateValid ? `(${formatDistanceToNow(orderDate, { addSuffix: true })})` : ''}
                    </p>
                    <span
                      className={`inline-block px-4 py-1.5 rounded-full text-xs font-semibold ${getStatusBadgeClasses(order.status)}`}
                    >
                      {order.status}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {selectedOrder && (
        <OrderDetailModal order={selectedOrder} onClose={handleCloseModal} />
      )}

      {/* Token Verification Popup - Integrated from WiFi.js */}
      {showTokenPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="bg-white w-full max-w-sm mx-auto rounded-lg shadow-lg p-6 text-center">
            {/* Centered LockKeyhole icon */}
            <div className="flex justify-center mb-4">
              <LockKeyhole className="w-8 h-8 text-blue-600" />
            </div>

            <h3 className="text-xl font-bold mb-4 text-gray-800">Enter Registration Token</h3>
            <p className="text-gray-700 mb-6">
              This is the first 5 characters of your Passport number or national ID number provided during registration.
            </p>
            <form onSubmit={handleTokenSubmit}>
              <div className="flex justify-center gap-2 mb-4">
                {[...Array(5)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={tokenInput[index] || ''}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    className="w-10 h-10 text-center text-lg font-semibold border rounded-lg border-gray-300 p-0"
                    autoFocus={index === 0}
                  />
                ))}
              </div>
              {tokenError && (
                <p className="text-sm text-red-500 mb-4">{tokenError}</p>
              )}

              <div className="text-center">
                <button
                  type="submit"
                  className={`px-6 py-2 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 ${
                    isLoading || tokenInput.length !== 5 ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                  disabled={isLoading || tokenInput.length !== 5}
                >
                  {isLoading ? "Verifying..." : "Submit"}
                </button>

                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="px-6 py-2 w-full bg-white text-gray-900 font-medium text-sm rounded-lg hover:bg-gray-100 mt-3"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
